import React from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import useGoBack from "../../hooks/useGoBack";

const BackButton = () => {
    // Back one page, or the login screen when there is no earlier in-app page
    const handleBackClick = useGoBack("/login");
    const { t } = useTranslation();

    return (
        <button type="button" className="auth-back" onClick={handleBackClick} aria-label={t("common.goBack")}>
            <FontAwesomeIcon icon={faArrowLeft} />
        </button>
    );
};

export default BackButton;
